/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, coloredScrollBar, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- REVENUE DRIVERS : STYLES --------------- ++++++++++ */
export default {
    revenuedrivers: {
        // display: 'flex',
        // flexDirection: 'column',
        // alignItems: 'center',
        padding: pxToEm(24),
        minHeight: pxToEm(457),
        // height: '100%',
        width: '100%',
        position: 'relative',
        background: 'white',
        '& .driverheader': {
            display: 'flex',
            alignItems: 'center',
            '& .productdropdown': {
                height: pxToEm(45),
                marginLeft: pxToEm(16),
                '& .name': {
                    display: 'none'
                },
                '& .selectors': {
                    display: 'none'
                }
            }
        },
        '& .data': {
            width: '100%',
            display: 'flex',
            height: '100%',
            // justifyContent: 'center',
            '& .responsiveline': {
                width: '100%',
                minWidth: '500px',
                // display: 'flex',
                // flexDirection: 'column',
                '& .title': {
                    color: themeV2.color.primary.main
                },
                '& .rollup': {
                    display: 'flex',
                    justifyContent: 'center',
                    '& .linkcontrols': {
                        marginBottom: '0'
                    }
                }
            },
            '& .chartcontainer': {
                overflowX: 'auto'
            },
            '& .table': {
                paddingLeft: '2%',
                width: '23%',
                '& .title_date': {
                    color: themeV2.color.base.gray.secondary,
                    height: pxToEm(40),
                    marginRight: pxToEm(24),
                    wordBreak: 'break-word'
                }
            }
        },
        '& .exportbutton': {
            fontWeight: 500,
			alignSelf: 'flex-end',
			height: pxToEm(36),
			padding: `${pxToEm(8)} ${pxToEm(16)}`,
            marginTop: pxToEm(75),
			maxWidth: pxToEm(112),
			background: 'none',
            float: 'right',
			'& .fa-arrow-down': {
				fontSize: pxToEm(16)
			}
        },
        extend: coloredScrollBar(themeV2.color.base.scrollbar)
    },
    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [`@media only screen and (max-width:${pxToEm(1100)})`]: {
        revenuedrivers: {
            '& .data': {
                flexDirection: 'column',
                '& .responsiveline': {
                    width: '100%'
                },
                '& .table': {
                    paddingLeft: '0',
                    width: '100%'
                }
            }
        }
    }
};
